import { LANGUAGES } from '@/utils/constants'

import { STAT_TYPES } from './stats.constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const RELOAD = 'reload'
export const DOWNLOAD_ALL_CHARTS = 'download-all-charts'
export const DOWNLOAD_ALL_TABLES = 'download-all-tables'

export default {
  [PORTUGUESE]: {
    [RELOAD]: 'Recarregar',
    [STAT_TYPES.PERFORMANCE]: 'PERFORMANCE',
    [STAT_TYPES.QUOTA]: 'COTA',
    [STAT_TYPES.QUESTIONS]: 'QUESTÕES',
    [DOWNLOAD_ALL_CHARTS]: 'Baixar gráficos (todos)',
    [DOWNLOAD_ALL_TABLES]: 'Baixar tabelas (todos)',
  },

  [ENGLISH]: {
    [RELOAD]: 'Reload',
    [STAT_TYPES.PERFORMANCE]: 'PERFORMANCE',
    [STAT_TYPES.QUOTA]: 'QUOTA',
    [STAT_TYPES.QUESTIONS]: 'QUESTIONS',
    [DOWNLOAD_ALL_CHARTS]: 'Download charts (all)',
    [DOWNLOAD_ALL_TABLES]: 'Download tables (all)',
  },

  [SPANISH]: {
    [RELOAD]: 'Recargar',
    [STAT_TYPES.PERFORMANCE]: 'PERFORMANCE',
    [STAT_TYPES.QUOTA]: 'CUOTA',
    [STAT_TYPES.QUESTIONS]: 'PREGUNTAS',
    [DOWNLOAD_ALL_CHARTS]: 'Descargar gráficos (todos)',
    [DOWNLOAD_ALL_TABLES]: 'Descargar tablas (todas)',
  },
}
